const Heart = ({ shapeColor, handleClick }) => {

  return (
    <svg onClick={handleClick ? handleClick : null} style={{ fill: shapeColor ? shapeColor : null }} xmlns="http://www.w3.org/2000/svg" width="390.479" height="307.81" viewBox="0 0 390.479 307.81" className="shape shape--heart">
      <path d="M194.17,303.262c31.966-68.5,58.932-61.678,137.757-114.415,4.652-3.108,16.746-11.884,22.609-17.573,23.2-22.52,33.442-44.118,33.442-73.481,0-.886-.067-2.755-.067-2.755C386.454,42.583,343.7.5,291.146.5S195.834,42.583,194.38,95.038H194.1C192.645,42.583,149.9.5,97.333.5S2.025,42.583.567,95.038c0,0-.067,1.87-.067,2.755,0,29.363,10.247,50.961,33.442,73.481,5.864,5.689,17.958,14.465,22.609,17.573C135.377,241.585,162.2,234.759,194.17,303.262Z" transform="translate(1 1)" />
    </svg>
  )
};

export default Heart;